import { useEffect } from 'react';

import { useFlowAnalyticsStore } from '@/v2/domains/Analytics/stores/flowAnalytics.store';
import { useFlowAnalyticsEventsQueueStore } from '@/v2/domains/Analytics/stores/flowAnalyticsEventsQueue.store';
import { FlowName } from '@/v2/domains/Analytics/types/common';

import useCalculateFlowFromQueue from '@/v2/domains/Analytics/hooks/useCalculateFlowFromQueue.hook';
import useTrackPlausibleFlowEvent from '../../hooks/useTrackPlausibleFlowEvent.hook';
import getFlowStepIndex from '../../utils/getFlowStepIndex';

export default function FlowAnalyticsEventsQueueManager({ children }) {
  const { pendingEvents, clearPendingEvents, setFlow } =
    useFlowAnalyticsEventsQueueStore();

  const { reset, initializeRunFlowId } = useFlowAnalyticsStore();
  const trackFlowEvent = useTrackPlausibleFlowEvent();
  const calculateFlowFromQueue = useCalculateFlowFromQueue();

  const sendQueuedEvents = (flow: FlowName) => {
    for (const { event, section, step } of pendingEvents) {
      trackFlowEvent({
        event,
        flow,
        section,
        step,
        stepIndex: getFlowStepIndex(flow, step),
      });
    }
    clearPendingEvents();
  };

  useEffect(() => {
    if (pendingEvents.length) {
      const flow = calculateFlowFromQueue(pendingEvents);
      if (flow) {
        reset(flow);
        initializeRunFlowId(flow);
        setFlow(flow);
        sendQueuedEvents(flow);
      }
    }
  }, [pendingEvents]);

  return children;
}
